module.exports = __webpack_public_path__ + "img/flip1.e59456ea.png";